import {
  appsWorkordersApiGetMaterialIssueGlobal,
  appsWorkordersApiListMaterialIssuesGlobal,
  getAppsWorkordersApiGetMaterialIssueGlobalQueryKey,
  getAppsWorkordersApiListMaterialIssuesGlobalQueryKey,
} from '@/lib/api/generated/endpoints'
import type { AppsWorkordersApiListMaterialIssuesGlobalParams } from '@/lib/api/generated/types.ts/appsWorkordersApiListMaterialIssuesGlobalParams'
import type { MaterialIssueOut } from '@/lib/api/generated/types.ts/materialIssueOut'
import { typedSuspenseOptions } from '@/lib/query/typed-suspense-query'

/**
 * Cross-WO MaterialIssueNote list — drives the global «Видачі в цех»
 * sidebar entry (ADR-0003 Iter 2 frontend).
 *
 * Backend: `GET /api/material-issues?project_id=&work_order_id=&status=&storekeeper_id=`.
 * MIN.work_order is nullable in the model but the current API uses atomic
 * `create_and_post` per WO — list is read-only at this layer; click opens
 * the WO detail page where the existing WoMaterialIssuesSection handles
 * post/unpost/delete-draft.
 */
export const materialIssuesGlobalListQuery = (
  params?: AppsWorkordersApiListMaterialIssuesGlobalParams,
) =>
  typedSuspenseOptions<readonly MaterialIssueOut[]>({
    queryKey: getAppsWorkordersApiListMaterialIssuesGlobalQueryKey(params),
    queryFn: ({ signal }) =>
      appsWorkordersApiListMaterialIssuesGlobal(params, { signal }) as unknown as Promise<
        readonly MaterialIssueOut[]
      >,
    staleTime: 15_000,
  })

/**
 * Single MIN getter for the standalone editor (read-only view; backend still
 * lacks a draft+update split, so create/edit flow stays in the WO detail
 * MIN-section). Adding the split is Plan §Phase E — when shipped, this
 * query can back a full draft editor.
 */
export const materialIssueDetailQuery = (materialIssueId: number) =>
  typedSuspenseOptions<MaterialIssueOut>({
    queryKey: getAppsWorkordersApiGetMaterialIssueGlobalQueryKey(materialIssueId),
    queryFn: ({ signal }) =>
      appsWorkordersApiGetMaterialIssueGlobal(materialIssueId, {
        signal,
      }) as unknown as Promise<MaterialIssueOut>,
    staleTime: 15_000,
  })
